export default __webpack_public_path__ + "static/media/Kozegeszsegugy.1f005e75.jpg";